import React from 'react';

import type { SpacingToken } from './util';
import {
    alignMap,
    calcSpacingPx,
    justifyMap,
} from './util';

type StackProps = {
    direction?: 'row' | 'column';
    align?: 'start' | 'end' | 'center' | 'stretch' | 'baseline';
    justify?: 'start' | 'end' | 'center' | 'between' | 'around' | 'evenly';
    wrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
    grow?: number;
    gap?: SpacingToken | number;
    w?: number | string;
    h?: number | string;
    p?: SpacingToken | number | string;
    px?: SpacingToken | number | string;
    py?: SpacingToken | number | string;
    pt?: SpacingToken | number | string;
    pb?: SpacingToken | number | string;
    pl?: SpacingToken | number | string;
    pr?: SpacingToken | number | string;
    m?: SpacingToken | number | string;
    mx?: SpacingToken | number | string;
    my?: SpacingToken | number | string;
    mt?: SpacingToken | number | string;
    mb?: SpacingToken | number | string;
    ml?: SpacingToken | number | string;
    mr?: SpacingToken | number | string;
    flex?: number | string;
} & React.HtmlHTMLAttributes<HTMLDivElement>;

const UiStackComponent: React.FC<StackProps> = ({
    children,
    ...props
}) => {
    const {
        align,
        justify,
        wrap,
        grow,
        gap,
        w,
        h,
        p,
        px,
        py,
        pt,
        pb,
        pl,
        pr,
        m,
        mt,
        mb,
        ml,
        mr,
        mx,
        my,
        flex,
        direction = 'row',
        style,
        ...rest
    } = props;

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: direction,
                alignItems: align ? alignMap[align] : undefined,
                justifyContent: justify ? justifyMap[justify] : undefined,
                flexWrap: wrap,
                flexGrow: grow,
                ...(flex !== undefined) && { flex },
                width: calcSpacingPx(w),
                height: calcSpacingPx(h),
                gap: calcSpacingPx(gap),
                padding: calcSpacingPx(p),
                ...(px !== undefined && {
                    paddingLeft: calcSpacingPx(px),
                    paddingRight: calcSpacingPx(px),
                }),
                ...(py !== undefined && {
                    paddingTop: calcSpacingPx(py),
                    paddingBottom: calcSpacingPx(py),
                }),
                ...(pt !== undefined && { paddingTop: calcSpacingPx(pt) }),
                ...(pb !== undefined && { paddingBottom: calcSpacingPx(pb) }),
                ...(pl !== undefined && { paddingLeft: calcSpacingPx(pl) }),
                ...(pr !== undefined && { paddingRight: calcSpacingPx(pr) }),
                margin: calcSpacingPx(m),
                ...(mx !== undefined && {
                    marginLeft: calcSpacingPx(mx),
                    marginRight: calcSpacingPx(mx),
                }),
                ...(my !== undefined && {
                    marginTop: calcSpacingPx(my),
                    marginBottom: calcSpacingPx(my),
                }),
                ...(mt !== undefined && { marginTop: calcSpacingPx(mt) }),
                ...(mb !== undefined && { marginBottom: calcSpacingPx(mb) }),
                ...(ml !== undefined && { marginLeft: calcSpacingPx(ml) }),
                ...(mr !== undefined && { marginRight: calcSpacingPx(mr) }),
                ...style,
            }}
            {...rest}>
            {children}
        </div>
    );
};

UiStackComponent.displayName = 'UiStack';
export const UiStack = UiStackComponent;
